import { Award, CheckCircle2, Layers, Send } from 'lucide-react';

export interface ActivitySummaryStats {
  total: number;
  upcoming: number;
  ongoing: number;
  completed: number;
}

interface ActivitySummaryWidgetProps {
  summaryStats: ActivitySummaryStats;
}

export function ActivitySummaryWidget({ summaryStats }: ActivitySummaryWidgetProps) {
  return (
    <div className="card bg-surface border border-line rounded-[16px] p-5 shadow-2xs flex flex-col gap-4">
      <h3 className="text-base font-bold text-ink tracking-tight">Activity Summary</h3>

      <div className="grid grid-cols-2 gap-3 sm:gap-3.5">
        {/* Total Activities */}
        <div className="p-3.5 rounded-[12px] bg-surface-2/70 border border-line/80 flex items-center gap-3 shadow-2xs">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[10px] bg-purple-500/15 text-purple-400 border border-purple-500/25">
            <Layers className="h-5 w-5" />
          </span>
          <div>
            <span className="text-[12px] font-bold text-ink-3  uppercase tracking-wide block">
              Total
            </span>
            <p className="text-2xl font-black text-ink mt-0.5 leading-tight font-mono">
              {String(summaryStats.total).padStart(1, '0')}
            </p>
          </div>
        </div>

        {/* Upcoming */}
        <div className="p-3.5 rounded-[12px] bg-surface-2/70 border border-line/80 flex items-center gap-3 shadow-2xs">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[10px] bg-blue-500/15 text-blue-400 border border-blue-500/25">
            <Send className="h-5 w-5" />
          </span>
          <div>
            <span className="text-[12px] font-bold text-ink-3  uppercase tracking-wide block">
              Upcoming
            </span>
            <p className="text-2xl font-black text-blue-400 mt-0.5 leading-tight font-mono">
              {String(summaryStats.upcoming).padStart(1, '0')}
            </p>
          </div>
        </div>

        {/* Ongoing */}
        <div className="p-3.5 rounded-[12px] bg-surface-2/70 border border-line/80 flex items-center gap-3 shadow-2xs">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[10px] bg-emerald-500/15 text-emerald-400 border border-emerald-500/25">
            <CheckCircle2 className="h-5 w-5" />
          </span>
          <div>
            <span className="text-[12px] font-bold text-ink-3  uppercase tracking-wide block">
              Ongoing
            </span>
            <p className="text-2xl font-black text-emerald-400 mt-0.5 leading-tight font-mono">
              {String(summaryStats.ongoing).padStart(1, '0')}
            </p>
          </div>
        </div>

        {/* Completed */}
        <div className="p-3.5 rounded-[12px] bg-surface-2/70 border border-line/80 flex items-center gap-3 shadow-2xs">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[10px] bg-indigo-500/15 text-indigo-400 border border-indigo-500/25">
            <Award className="h-5 w-5" />
          </span>
          <div>
            <span className="text-[12px] font-bold text-ink-3  uppercase tracking-wide block">
              Completed
            </span>
            <p className="text-2xl font-black text-indigo-400 mt-0.5 leading-tight font-mono">
              {String(summaryStats.completed).padStart(1, '0')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
